import { Heading, HeadingProps, useStyles } from '@chakra-ui/react';
import { mergeWith } from '@chakra-ui/utils';
import PropTypes from 'prop-types';
import React from 'react';

import { useCardContext } from './CardContext';
import DisplayNames from './enums';

export type CardContentHeadingProps = HeadingProps;

const CardContentHeading = (props: CardContentHeadingProps): React.ReactElement => {
  const themeStyles = useStyles();
  const { isDisabled } = useCardContext();
  const { __css, ...rest } = props;

  const computedProps: HeadingProps = {
    as: 'p',
    ...(isDisabled ? { 'data-disabled': true } : {}),
    ...mergeWith(themeStyles.cardContentHeading as HeadingProps, __css),
    ...rest
  };

  return <Heading {...computedProps} />;
};

CardContentHeading.propTypes = {
  children: PropTypes.string.isRequired
};
CardContentHeading.defaultProps = {};
CardContentHeading.displayName = DisplayNames.CardContentHeading;

export default CardContentHeading;
